(() => {
  if (window.olBestProductPrice) return;
  const useBestPrice = () => {
    const settings = window.Samita?.Wholesale?.shop?.settings;
    if (!settings) return;
    settings.general ||= {};
    settings.general.cart_page ||= {};
    settings.general.cart_page.discount_combination = false;
  };
  window.olBestProductPrice = true;
  document.addEventListener('samitaWS.scripts.loaded', useBestPrice);
  window.addEventListener('samitaWSRenderWholesaleCompleted', useBestPrice);
  useBestPrice();
  window.addEventListener('click', event => {
    if (!event.target.closest?.('button[name="checkout"], .samitaWS-clone-checkout-button')) return;
    const cart = window.Samita?.Wholesale?.cart;
    if (!cart?.items) return;
    cart.total_discount = 0;
    if (cart.attributes) delete cart.attributes.wsSamita;
    for (const item of cart.items) {
      item.total_discount = 0;
      item.discounts = [];
      item.line_level_discount_allocations = [];
      item.price = item.original_price;
      item.final_price = item.original_price;
      item.line_price = item.original_line_price;
      item.final_line_price = item.original_line_price;
    }
    cart.total_price = cart.items.reduce((total, item) => total + item.original_line_price, 0);
  }, true);
  const cents = value => {
    const cleaned = value.replace(/[^0-9.,]/g, '');
    const last = Math.max(cleaned.lastIndexOf(','), cleaned.lastIndexOf('.'));
    return last >= 0 && cleaned.length - last === 3
      ? Number(cleaned.slice(0, last).replace(/[.,]/g, '')) * 100 + Number(cleaned.slice(last + 1))
      : Number(cleaned.replace(/[.,]/g, '')) * 100;
  };
  let pending = false;
  const preserveBetterPrices = () => {
    pending = false;
    const summary = document.getElementById('cart-summary');
    const cartItems = summary?.closest('.cc-main-cart')?.querySelector('cart-items') || document.querySelector('cart-items');
    const cells = [...(cartItems?.querySelectorAll('[data-ol-server-total]') || [])];
    for (const cell of cells) {
      const native = Number(cell.dataset.olServerTotal);
      const amounts = (cell.textContent.match(/[0-9]+(?:[.,][0-9]+)*/g) || []).map(cents);
      if (!amounts.length || Math.min(...amounts) <= native) continue;
      const strong = document.createElement('strong');
      strong.textContent = new Intl.NumberFormat(cell.dataset.olLocale, { style: 'currency', currency: cell.dataset.olCurrency }).format(native / 100) + ' ' + cell.dataset.olTax;
      cell.replaceChildren(strong);
    }
    const prices = summary?.querySelector('.partner-cart-total__prices');
    const server = cartItems?.querySelector('[data-ol-cart-total]');
    if (!prices || !cells.length || !server) return;
    const format = new Intl.NumberFormat(cells[0].dataset.olLocale, { style: 'currency', currency: cells[0].dataset.olCurrency });
    const tax = cells[0].dataset.olTax;
    const lineTotal = cells.reduce((sum, cell) => {
      const amounts = (cell.textContent.match(/[0-9]+(?:[.,][0-9]+)*/g) || []).map(cents);
      return sum + Math.min(Number(cell.dataset.olServerTotal), ...amounts);
    }, 0);
    const total = Math.min(lineTotal, Number(server.dataset.olCartTotal));
    const original = cells.reduce((sum, cell) => sum + Number(cell.dataset.olOriginalTotal), 0);
    const saving = original - total;
    const expected = (saving > 0 ? format.format(original / 100) + ' ' + tax : '') + format.format(total / 100) + ' ' + tax;
    const compact = value => value.replace(/\s/g, '');
    const priceNode = (tag, amount) => {
      const node = document.createElement(tag);
      node.append(format.format(amount / 100) + ' ');
      const small = document.createElement('small');
      small.style.cssText = 'color:#999;font-size:0.5em';
      small.textContent = tax;
      node.append(small);
      return node;
    };
    if (compact(prices.textContent) !== compact(expected)) {
      prices.replaceChildren(...(saving > 0 ? [priceNode('s', original)] : []), priceNode('strong', total));
    }
    let savingRow = summary.querySelector('.partner-cart-savings');
    if (saving > 0 && !savingRow) {
      savingRow = document.createElement('div');
      savingRow.className = 'partner-cart-savings';
      const label = document.createElement('span');
      label.textContent = cells[0].dataset.olLocale.startsWith('de') ? 'Deine Ersparnis' : 'Your savings';
      savingRow.append(label, document.createElement('span'));
      prices.parentElement.before(savingRow);
    }
    if (savingRow) {
      savingRow.hidden = saving <= 0;
      const value = '-' + format.format(saving / 100) + ' ' + tax;
      if (savingRow.lastElementChild.textContent !== value) savingRow.lastElementChild.textContent = value;
    }
  };
  const observer = new MutationObserver(changes => {
    if (pending || !changes.some(change => (change.target.nodeType === 1 ? change.target : change.target.parentElement)?.closest('cart-items, #cart-summary'))) return;
    pending = true;
    queueMicrotask(preserveBetterPrices);
  });
  observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  preserveBetterPrices();
})();
